import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { RegistrationData } from "../widget.model";
import { environment } from "../../environments/environment";

declare const grecaptcha: any;

@Component({
  selector: "step-three",
  templateUrl: "./step-three.component.html",
})
export class StepThreeComponent implements OnInit {
  @Input() errorPatientExist: boolean;
  @Input() errorNotExist: boolean;
  @Input() selectedLanguageIsoCode: string;
  registerTabSelected: boolean;
  loginTabSelected: boolean;
  token: string;
  showRecaptchaError = false;
  initRecaptcha =
    environment.websiteRecaptchaKey && environment.websiteRecaptchaKey !== "";

  @Output() sendPersonInfo = new EventEmitter();

  constructor() {}

  ngOnInit() {
    if (this.initRecaptcha) {
      const script = document.createElement("script");
      script.src =
        "https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit";
      script.defer = true;
      script.onload = () => {
        grecaptcha.ready(function () {
          grecaptcha.render("recap", {
            // sitekey: "6LceG58pAAAAAH270xxCQTXyBACcnRpt5GexmwjD",
            sitekey: "6LfcZ18rAAAAAD8KJkbRkBaQX8kmirc6ZB09Kgnx",
            callback: function () {
              var el = document.getElementById("submitAppointmentBooking");
              if (!el) return;
              (el as HTMLButtonElement).disabled = false;
            },
            "expired-callback": function () {},
          });
        });
      };
      document.body.appendChild(script);
    }
  }

  sendRegistrationData(patientRegistrationData: RegistrationData) {
    if (this.initRecaptcha) {
      const token = grecaptcha.getResponse();
      if (!token) {
        this.showRecaptchaError = true;
        setTimeout(() => {
          this.showRecaptchaError = false;
        }, 3000);
        return;
      }
    }

    this.sendPersonInfo.next({
      type: "registration",
      firstName: patientRegistrationData.firstName,
      lastName: patientRegistrationData.lastName,
      birthDate: patientRegistrationData.birthDate,
      communicationChannels: [
        {
          id: null,
          typeId: "6a21617c-d92d-4784-ad3c-2a62861e6500",
          content: patientRegistrationData.telNumber,
          label: "mobile-phone",
        },
        {
          id: null,
          typeId: "c41eddc2-827e-47de-9502-06ad7cfcea4e",
          content: patientRegistrationData.email,
          label: "email",
        },
      ],
    });
  }

  sendLoginData(patientRegistrationData: RegistrationData) {
    if (this.initRecaptcha) {
      const token = grecaptcha.getResponse();
      if (!token) {
        this.showRecaptchaError = true;
        setTimeout(() => {
          this.showRecaptchaError = false;
        }, 3000);
        return;
      }
    }

    this.sendPersonInfo.next({
      type: "login",
      communicationChannels: [
        {
          id: null,
          typeId: "c41eddc2-827e-47de-9502-06ad7cfcea4e",
          content: patientRegistrationData.email,
          label: "email",
        },
      ],
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/strahinja.aparac/Desktop/git/source/healthcare/v2/app/appointment-widget/src/app/step-three/step-three.component.ts